import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from '@livecommerce/design-system';
import camelCase from 'lodash/camelCase.js';
import { deleteDialogNotification } from 'actions/notifications.js';

const NotificationModal = () => {
  const data = useSelector((state) => state.notifications.dialog);
  const dispatch = useDispatch();
  if (!data) return null;

  const { title = null, message = null, action, actionText = null } = data;

  const handleAction = () => {
    if (typeof action === 'function') action();
    dispatch(deleteDialogNotification());
  };

  return (
    <Modal
      name={camelCase(title)}
      isModalOpen
      title={title}
      onClose={handleAction}
      variant="confirmation"
      actions={
        <Button type="button" variant="primary" onClick={handleAction}>
          {actionText}
        </Button>
      }
    >
      {message}
    </Modal>
  );
};

export default NotificationModal;
